import { ActionIcon, Group, Tooltip } from '@mantine/core';
import type { AdminListUsersQuery } from '@src/__generated__/graphql';
import { IconPasswordUser, IconPencil, IconUserCheck, IconUserOff } from '@tabler/icons-react';

type AdminUserSummary = AdminListUsersQuery['adminListUsers']['items'][number];

interface AdminUserRowActionsProps {
  record: AdminUserSummary;
  isToggling: boolean;
  resetPasswordLoading: boolean;
  pendingActionKey: string | null;
  onEdit: (record: AdminUserSummary) => void;
  onToggle: (record: AdminUserSummary) => void;
  onResetPassword: (record: AdminUserSummary) => void;
}

function AdminUserRowActions({
  record,
  isToggling,
  resetPasswordLoading,
  pendingActionKey,
  onEdit,
  onToggle,
  onResetPassword,
}: AdminUserRowActionsProps) {
  return (
    <Group gap="xs">
      <Tooltip label="Edit user">
        <ActionIcon
          variant="light"
          color="gray"
          onClick={(event) => {
            event.stopPropagation();
            onEdit(record);
          }}
          aria-label={`Edit ${record.username}`}
        >
          <IconPencil size={16} />
        </ActionIcon>
      </Tooltip>

      <Tooltip label={record.enabled ? 'Disable user' : 'Enable user'}>
        <ActionIcon
          variant="light"
          color={record.enabled ? 'red' : 'green'}
          onClick={(event) => {
            event.stopPropagation();
            onToggle(record);
          }}
          loading={isToggling && pendingActionKey === `${record.username}:toggle`}
          aria-label={record.enabled ? `Disable ${record.username}` : `Enable ${record.username}`}
        >
          {record.enabled ? <IconUserOff size={16} /> : <IconUserCheck size={16} />}
        </ActionIcon>
      </Tooltip>

      <Tooltip label="Force Password Reset">
        <ActionIcon
          variant="light"
          color="blue"
          onClick={(event) => {
            event.stopPropagation();
            onResetPassword(record);
          }}
          loading={resetPasswordLoading && pendingActionKey === `${record.username}:reset`}
          aria-label={`Reset password for ${record.username}`}
        >
          <IconPasswordUser size={16} />
        </ActionIcon>
      </Tooltip>
    </Group>
  );
}

export default AdminUserRowActions;
